import { createContext } from 'react';
import type { ThemeContextValue } from '@/context/themeTypes';

export const ThemeContext = createContext<ThemeContextValue | null>(null);
